export default "__VITE_ASSET__BiIWn81A__"